import React, { useEffect, useRef, useState } from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import useToken from '../App/useToken';

function AdminUsers() {
    const { token } = useToken();
    const toast = useRef(null);
    const [users, setUsers] = useState([]);
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
    });

    useEffect(() => {
        loadUsers();
    }, []);

    const authHeaders = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
    };

    const loadUsers = () => {
        fetch(process.env.REACT_APP_URL + 'auth/users', {
            method: 'GET',
            headers: authHeaders,
        })
            .then(parseResponse)
            .then((data) => setUsers(Array.isArray(data) ? data : []));
    };

    const onChange = (event, field) => {
        setForm({ ...form, [field]: event.target.value });
    };

    const resetForm = () => {
        setForm({
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
        });
    };

    const errorMessage = (data) => {
        if (data.errors) {
            const firstField = Object.keys(data.errors)[0];
            return firstField ? data.errors[firstField][0] : 'No se pudo crear el usuario';
        }

        if (data.mensaje) {
            return data.mensaje;
        }

        if (data.message) {
            return data.message;
        }

        return 'No se pudo crear el usuario';
    };

    const parseResponse = (response) => {
        return response.text().then((text) => {
            if (!text) {
                return { code: response.ok ? 200 : response.status };
            }

            try {
                return JSON.parse(text);
            }
            catch (error) {
                return {
                    code: response.status,
                    mensaje: response.ok ? text : 'El servidor devolvio una respuesta inesperada. Revisa el log del backend.',
                };
            }
        });
    };

    const saveUser = () => {
        setSaving(true);

        fetch(process.env.REACT_APP_URL + 'auth/users', {
            method: 'POST',
            headers: authHeaders,
            body: JSON.stringify(form),
        })
            .then(parseResponse)
            .then((data) => {
                if (data.code === 200) {
                    toast.current.show({ severity: 'success', summary: 'Usuarios', detail: data.mensaje, life: 3000 });
                    resetForm();
                    loadUsers();
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage(data), life: 5000 });
                }
            })
            .finally(() => setSaving(false));
    };

    return (
        <div className="surface-0 p-4">
            <Toast ref={toast} />

            <div className="mb-4">
                <h2>Usuarios</h2>
                <p>Solo el administrador puede crear usuarios. El puntaje inicial se asigna con el total del ultimo jugador del ranking.</p>
            </div>

            <div className="card mb-4">
                <h5>Crear usuario</h5>
                <div className="p-fluid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="name">Nombre</label>
                        <InputText id="name" value={form.name} onChange={(e) => onChange(e, 'name')} />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="email">Email</label>
                        <InputText id="email" type="email" value={form.email} onChange={(e) => onChange(e, 'email')} />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="password">Password</label>
                        <Password id="password" value={form.password} feedback={false} toggleMask onChange={(e) => onChange(e, 'password')} />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="password_confirmation">Confirmar password</label>
                        <Password id="password_confirmation" value={form.password_confirmation} feedback={false} toggleMask onChange={(e) => onChange(e, 'password_confirmation')} />
                    </div>
                </div>

                <Button label="Crear usuario" icon="pi pi-user-plus" className="p-button-success" disabled={saving} onClick={saveUser} />
            </div>

            <div className="card">
                <h5>Usuarios registrados</h5>
                <DataTable value={users} paginator rows={10} rowsPerPageOptions={[10, 20, 50]} responsiveLayout="scroll">
                    <Column field="name" header="Nombre" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column field="email" header="Email" sortable style={{ minWidth: '14rem' }}></Column>
                    <Column field="puntaje_inicial" header="Inicial" sortable style={{ maxWidth: '6rem' }}></Column>
                    <Column field="puntaje_total" header="Total" sortable style={{ maxWidth: '6rem' }}></Column>
                    <Column field="created_at" header="Creado" sortable style={{ minWidth: '12rem' }}></Column>
                </DataTable>
            </div>
        </div>
    );
}

export default AdminUsers;
